import {
    DigestFilter,
    DigestFilterColumn,
    DigestFilterOperator,
    DigestLogicalOperator,
} from "../../../../../Common/CandyApiClient/DigestApiClient/Types/DigestQueryFilter";
import {
    FilterBuilder,
    isResolveToAllFilter,
    isResolveToNoneFilter,
    ResolveToAllFilter,
    resolveToAllFilter,
    ResolveToNoneFilter,
    resolveToNoneFilter,
} from "../Picklist/Common/FilterBuilder";
import { isNullOrEmpty } from "../../../../../Common/TypingUtils";

import { ComboBoxProps } from "./ComboBox";
import { getColumnNames } from "./getColumnNames";

export type FilterFunc = (
    builder: FilterBuilder,
    none: ResolveToNoneFilter,
    all: ResolveToAllFilter
) => undefined | null | FilterBuilder | ResolveToNoneFilter | ResolveToAllFilter;

export type BuildFilterCallback = (
    builder: FilterBuilder,
    none: ResolveToNoneFilter,
    all: ResolveToAllFilter
) => undefined | null | FilterBuilder | ResolveToNoneFilter | ResolveToAllFilter;

export const tryBuildUserFilter = (
    filter?: FilterFunc
): { hasValidUserFilter: boolean; userFilter: undefined | DigestFilter } => {
    if (filter == undefined) {
        return { hasValidUserFilter: true, userFilter: undefined };
    }
    let userFilter: undefined | DigestFilter;
    const userFilterBuilder = filter(new FilterBuilder(), resolveToNoneFilter, resolveToAllFilter);
    if (userFilterBuilder == undefined) {
        userFilter = undefined;
    } else if (isResolveToAllFilter(userFilterBuilder)) {
        userFilter = undefined;
    } else if (isResolveToNoneFilter(userFilterBuilder)) {
        return { hasValidUserFilter: false, userFilter: undefined };
    } else {
        userFilter = userFilterBuilder.build();
    }

    return { hasValidUserFilter: true, userFilter: userFilter };
};

export const buildSearchFilter = (value: string, comboboxProps: ComboBoxProps): undefined | DigestFilter => {
    const { keyColumnName, valueColumnName, searchColumnNames } = getColumnNames(comboboxProps);
    return {
        operator: DigestLogicalOperator.Or,
        operands: [
            ...searchColumnNames.map(c => ({ operator: DigestFilterOperator.Substring, column: `${c}`, value: value })),
            { operator: DigestFilterOperator.Substring, column: `${valueColumnName}`, value: value },
            { operator: DigestFilterOperator.Prefix, column: `${keyColumnName}`, value: value },
            { operator: DigestFilterOperator.Substring, column: `${keyColumnName}`, value: value },
        ],
    };
};

export const buildAutoValueFilter = (comboboxProps: ComboBoxProps): undefined | DigestFilterColumn => {
    const { autoValue } = comboboxProps;

    if (isNullOrEmpty(autoValue)) {
        return undefined;
    }

    const { keyColumnName } = getColumnNames(comboboxProps);
    return {
        operator: DigestFilterOperator.Equal,
        column: `${keyColumnName}`,
        value: autoValue,
    };
};

export const buildEmptyValueFilter = (emptyValueFilter?: BuildFilterCallback): undefined | DigestFilter => {
    const result = emptyValueFilter?.(new FilterBuilder(), resolveToNoneFilter, resolveToAllFilter);
    if (result == undefined || isResolveToNoneFilter(result) || isResolveToAllFilter(result)) {
        return undefined;
    }
    return result.build();
};
